export default __webpack_public_path__ + "static/explore-ec36b3c39ed3fbc5113b1aac551b0da2.png";